import * as React from 'react';
import { getCookie, deleteCookie } from '../../lib/utils';

export default function LaunchplanForm({ blok }) {
  const {button_cookie_text, button_text, klaviyo_id} = blok;
  const [isKlaviyoAccepted, setIsKlaviyoAccepted] = React.useState(false);
  const formRef = React.useRef();

  React.useEffect(() => {
    const checkKlaviyoCookie = () => {
      const klaviyoCookie = getCookie('gatsby-gdpr-klaviyo');
      setIsKlaviyoAccepted(klaviyoCookie === 'true');
    };
    checkKlaviyoCookie();
    document.documentElement.addEventListener('cookies:updated', checkKlaviyoCookie);
    return () => {
      document.documentElement.removeEventListener('cookies:updated', checkKlaviyoCookie);
    };
  }, []);

  function openCookieSettings() {
    Object.keys(window.gatsbyPluginGDPRCookiesOptions).forEach((key) => {
      if (key !== 'environments' && key !== 'plugins' && key) {
        localStorage.removeItem(window.gatsbyPluginGDPRCookiesOptions[key].cookieName);
        if (
          getCookie(window.gatsbyPluginGDPRCookiesOptions[key].cookieName) !== ''
        ) {
          localStorage.setItem(
            window.gatsbyPluginGDPRCookiesOptions[key].cookieName,
            getCookie(window.gatsbyPluginGDPRCookiesOptions[key].cookieName),
          );
        }
        deleteCookie(window.gatsbyPluginGDPRCookiesOptions[key].cookieName);
      }
    });
    localStorage.removeItem('cookieConsent');
    deleteCookie('cookieConsent');
    window.location.reload();
  }
  return (
    <div className="px-4 lg:px-16 py-20">
      {isKlaviyoAccepted ? (
        <div
          className={`klaviyo-form-${klaviyo_id} cursor-pointer my-10`}
          id="launchplan-form"
          data-klaviyo-accepted={isKlaviyoAccepted}
          ref={formRef}
        />
      ) : (
        <div className="min-h-[50px] my-10">
          <button
            type="button"
            className="underline cursor-pointer"
            onClick={openCookieSettings}
          >
            {button_cookie_text}
          </button>
          <p className="inline">
            {' '}
            {button_text}
          </p>
        </div>
      )}
    </div>
  );
}
